const Theme = {
  logo_image_url: 'onedrop.png',
  logo_height: 54,

  button_color: '#81cfcf',
  button_text_color: '#23325b',
  button_text_uppercase: true,

  text_font: `'Rubik', sans-serif`,
  title_font: `'Rubik', sans-serif`,
}

export default Theme
